<template>
  <div class="detail-res-complex">
    <v-row>
      <v-col cols="12" md="5" class="detail-res-complex__col-left">
        <div class="detail-res-complex__section">
          <h2 class="detail-res-complex__section-title">
            Жилой комплекс {{ resResidentComplex.name }}
          </h2>
          <v-row class="detail-res-complex__form-row">
            <v-col cols="12" class="detail-res-complex__col">
              <div class="detail-res-complex__counters">
                <span class="detail-res-complex__counter">Домофоны: {{ doorphoneCount }}</span>
                <span class="detail-res-complex__counter">Калитки: {{ gateCount }}</span>
                <span class="detail-res-complex__counter">Шлагбаумы: {{ barrierCount }}</span>
              </div>
            </v-col>
            <v-col cols="12" class="detail-res-complex__col">
              <v-text-field
                label="Название"
                outlined
                dense
                hide-details
                clearable
                v-model="name"
                prepend-inner-icon="mdi-rename-box-outline"
              />
            </v-col>
            <v-col cols="12" class="detail-res-complex__col">
              <v-textarea
                v-model="comment"
                label="Комментарий"
                outlined
                dense
                rows="2"
                auto-grow
                hide-details
                prepend-inner-icon="mdi-comment-outline"
              />
            </v-col>
          </v-row>
        </div>

        <div class="detail-res-complex__card mt-4">
          <v-tabs v-model="activeTab" class="detail-res-complex__tabs" show-arrows="mobile">
            <v-tab>Привязанные Домофоны</v-tab>
            <v-tab>Привязанные Шлагбаумы</v-tab>
            <v-tab-item>
              <v-data-table
                class="table"
                :headers="headersDoorphonesTied"
                :items="resResidentComplex.doorphones"
                :items-per-page="5"
                :footer-props="{
                      'items-per-page-options': [5, 10],
                       showFirstLastPage: true,
                    }"
              >
                <template v-slot:item.address="{ item }">
                  <router-link class="routerLink" :to="`/doorphones/${item.id}`">
                    {{ item.address }}
                  </router-link>
                </template>
                <template v-slot:item.type="{ item }">
                  <div v-if="item.type === 'M'">Домофон</div>
                  <div v-if="item.type === 'G'">Калитка</div>
                  <div v-if="item.type === 'A'">Доп.вход</div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        text
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="#1E6CEB"
                        class="text-none btn__icon ml-1 mr-1"
                        width="18"
                        height="18"
                        :to="`/map/none/doorphone/${item.id}`"
                      >
                        <v-icon color="green">mdi-map-marker-right-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Домофон на карте</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        text
                        tile
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="btn__icon pa-0 mr-1 ml-2"
                        width="18"
                        height="18"
                        @click.stop="$set(deleteDialog, item.id, true)"
                      >
                        <v-icon size="large">mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                  <v-dialog v-model="deleteDialog[item.id]" width="500" content-class="dialog-border-radius">
                    <BaseDeleteModal
                      :active.sync="deleteDialog[item.id]"
                      @close="$set(deleteDialog, item.id, false)"
                      @submit="removeAccessDevice(item.id)"
                      messageTitle="Удалить домофон?"
                      messageText="Подтверждая, вы удалите домофон из списка жилого комплекса."
                      confirmText="Удалить"
                      cancelText="Отмена"
                      confirmColor="error"
                    />
                  </v-dialog>
                </template>
              </v-data-table>
            </v-tab-item>
          <v-tab-item>
            <base-toggle-status-barriers
              :barriers="resResidentComplex.barriers"
              @getResidentComplex="getResidentComplex"
            />
            <v-data-table
              class="table"
              :headers="headersBarriersTied"
              :items="resResidentComplex.barriers"
              :items-per-page="5"
              :footer-props="{
                'items-per-page-options': [5, 10],
                 showFirstLastPage: true,
              }"
              :disable-sort="true"
            >
              <template v-slot:item.status_condition="{ item }">
                <div v-if="item.status_condition === 'on'" style="color: #388E3C">Действующий</div>
                <div v-if="item.status_condition === 'off'" style="color: crimson">Заблокирован</div>
                <div v-if="!item.device_id">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        width="18"
                        height="18"
                      >
                        <v-icon x-small color="orange">mdi-checkbox-blank-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Старый шлагбаум</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:item.address="{ item }">
                <router-link class="routerLink" :to="`/barrier/${item.id}`">
                  {{ item.address }}{{ getPassageType(item.type) }}
                </router-link>
              </template>
              <template v-slot:item.sip_status="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      width="18"
                      height="18"
                    >
                      <v-icon x-small :color="item.sip_status_color">mdi-checkbox-blank-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.sip_status_text }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      text
                      tile
                      small
                      v-bind="attrs"
                      v-on="on"
                      class="btn__icon pa-0 mr-1 ml-2"
                      width="18"
                      height="18"
                      @click.stop="$set(deleteDialog, item.id, true)"
                    >
                      <v-icon size="large">mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Удалить</span>
                </v-tooltip>
                <v-dialog v-model="deleteDialog[item.id]" width="500" content-class="dialog-border-radius">
                  <BaseDeleteModal
                    :active.sync="deleteDialog[item.id]"
                    @close="$set(deleteDialog, item.id, false)"
                    @submit="removeAccessDevice(item.id, true)"
                    messageTitle="Удалить шлагбаум?"
                    messageText="Подтверждая, вы удалите шлагбаум из списка жилого комплекса."
                    confirmText="Удалить"
                    cancelText="Отмена"
                    confirmColor="error"
                  />
                </v-dialog>
              </template>
            </v-data-table>
          </v-tab-item>
          </v-tabs>
        </div>

        <div class="detail-res-complex__actions">
          <div class="detail-res-complex__actions-left">
            <v-btn
              color="primary"
              class="text-none"
              rounded
              @click="validate()"
            >
              <v-icon left>mdi-content-save-outline</v-icon>
              Сохранить
            </v-btn>
            <v-btn
              color="primary"
              outlined
              class="text-none"
              rounded
              @click="close()"
            >
              <v-icon left>mdi-close</v-icon>
              Отмена
            </v-btn>
          </div>
          <v-btn
            v-if="canDeleteResidentialComplex"
            color="error"
            outlined
            class="text-none"
            rounded
            @click.stop="$set(deleteDialogResComplex, resResidentComplex.id, true)"
          >
            <v-icon left>mdi-delete-outline</v-icon>
            Удалить ЖК
          </v-btn>
        </div>

        <v-dialog v-model="deleteDialogResComplex[resResidentComplex.id]" width="500" content-class="dialog-border-radius">
          <BaseDeleteModal
            :active.sync="deleteDialogResComplex[resResidentComplex.id]"
            @close="$set(deleteDialogResComplex, resResidentComplex.id, false)"
            @submit="removeComplex(resResidentComplex.id, resResidentComplex.name)"
            messageTitle="Удалить жилой комплекс?"
            messageText="Подтверждая, вы удалите жилой комплекс."
            confirmText="Удалить"
            cancelText="Отмена"
            confirmColor="error"
          />
        </v-dialog>
      </v-col>
    <v-col cols="12" md="7" class="pb-0">
      <v-progress-linear v-if="loading" indeterminate color="primary" class="detail-res-complex__progress" />
      <div class="detail-res-complex__search-card">
        <div class="detail-res-complex__filters">
          <div class="detail-res-complex__filters-title">
            <v-icon left small>mdi-magnify</v-icon>
            Поиск
          </div>
          <div class="detail-res-complex__filters-row">
            <v-text-field
              v-model="filterAddress"
              @keyup="validateKeyUp"
              label="По адресу"
              outlined
              dense
              hide-details
              clearable
              class="detail-res-complex__field"
              prepend-inner-icon="mdi-rename-box-outline"
              autocomplete="off"
            />
            <v-text-field
              v-model="filterIdDoorphone"
              @keyup="validateKeyUp"
              label="По id домофона"
              outlined
              dense
              hide-details
              clearable
              class="detail-res-complex__field"
              prepend-inner-icon="mdi-home-account"
              autocomplete="off"
            />
            <v-text-field
              v-model="filterIdBarrier"
              @keyup="validateKeyUp"
              label="По id шлагбаума"
              outlined
              dense
              hide-details
              clearable
              class="detail-res-complex__field"
              prepend-inner-icon="mdi-home-account"
              autocomplete="off"
            />
            <v-btn
              color="primary"
              class="text-none detail-res-complex__search-btn"
              dark
              rounded
              @click.prevent="filterDoorphones"
            >
              <v-icon left>mdi-magnify</v-icon>
              Поиск
            </v-btn>
          </div>
        </div>
        <div class="detail-res-complex__table-wrap">
        <v-data-table
          class="table"
          v-model="selectedDoorphones"
          :headers="headersDoorphones"
          :items="listDisplayDoorphones"
          item-key="uniqueId"
          show-select
          :footer-props="{
            'items-per-page-options': [10, 20, 50],
            showFirstLastPage: true,
          }"
          :disable-sort="true"
        >
          <template v-slot:header.snapshotImage>
            Изображение
            <v-icon @click="showSnapshot = !showSnapshot">mdi-image</v-icon>
          </template>
          <template v-slot:item.address="{ item }">
            {{ item.address }}
          </template>
          <template v-slot:item.snapshotImage="{ item }">
            <v-img
              v-if="showSnapshot"
              :src="`${item.snapshot}`"
              max-width="150"
              class="ml-auto mr-auto my-4"
              contain
            ></v-img>
          </template>
          <template v-slot:item.sip_status="{ item }">
            <div>
              <v-icon x-small :color="item.sip_status_color">
                mdi-checkbox-blank-circle
              </v-icon>
              {{ item.sip_status_text }}
            </div>
          </template>
        </v-data-table>
        </div>
      </div>
    </v-col>
  </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseDeleteModal from '@/components/BaseDeleteModal';
import BaseToggleStatusBarriers from '@/components/residentComplex/BaseToggleStatusBarriers';

export default {
  name: 'DetailResidentComplex',
  components: { BaseDeleteModal, BaseToggleStatusBarriers },
  props: ['id'],
  data: () => ({
    isCreated: false,
    showSnapshot: false,
    deleteDialog: {},
    activeTab: 0,
    deleteDialogResComplex: {},
    resResidentComplex: [],
    resComById: 'none',
    attachedDoorphones: [],
    attachedBarriers: [],
    selectedDoorphones: [],
    combinedArrayId: [],
    listDoorphonesdelete: [],
    filterManagementCompany: '',
    name: null,
    totalDoorphones: 0,
    filterAddress: '',
    comment: '',
    filterIdDoorphone: '',
    filterIdBarrier: '',
    loading: true,
    options: {
      itemsPerPage: 10,
    },
    filters: {},
    sort: '',
    SCUD: [],
    headersDoorphones: [
      { text: 'id', value: 'uniqueId' },
      { text: 'Адрес', value: 'address' },
      { text: 'Агент', value: 'agent', width: '18%' },
      { text: 'Статус', value: 'sip_status' },
      { text: 'Изображение', value: 'snapshotImage' },
    ],
    headersDoorphonesTied: [
      { text: 'id', value: 'id', sortable: false },
      { text: 'Адрес', value: 'address', sortable: false },
      { text: 'Тип', value: 'type' },
      { text: '', value: 'actions', width: '15%', sortable: false },
    ],
    headersBarriersTied: [
      { text: 'id', value: 'id' },
      { text: 'Адрес', value: 'address' },
      { text: 'Статус грз', value: 'status_condition' },
      { text: 'sip', value: 'sip_status' },
      { text: '', value: 'actions', width: '10%' },
    ],
  }),
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.loadDoorphones();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
  created () {
    this.getResidentComplex();
    this.isCreated = true;
    this.sort = ['-id'];
    if (Object.keys(this.$route.query).length) {
      const routeQuery = this.$route.query;

      if (routeQuery.address) {
        this.filterAddress = routeQuery.address;
        this.filters.address = routeQuery.address;
      }
    }
    this.loadDoorphones();
  },
  computed: {
    ...mapGetters({
      doorphones: 'Doorphone/mapDoorphones',
    }),
    listDisplayDoorphones () {
      if (this.attachedDoorphones && this.attachedBarriers) {
        return this.SCUD.filter(doorphone => {
          return !this.attachedDoorphones.includes(doorphone.id) && !this.attachedBarriers.includes(doorphone.id);
        });
      }
      return this.SCUD;
    },
    doorphoneCount () {
      if (this.resResidentComplex && this.resResidentComplex.doorphones) {
        return this.resResidentComplex.doorphones.filter(doorphone => doorphone.type === 'M').length;
      }
      return 0;
    },
    gateCount () {
      if (this.resResidentComplex && this.resResidentComplex.doorphones) {
        return this.resResidentComplex.doorphones.filter(doorphone => doorphone.type === 'G').length;
      }
      return 0;
    },
    barrierCount () {
      return this.resResidentComplex.barriers ? this.resResidentComplex.barriers.length : 0;
    },
    canDeleteResidentialComplex () {
      const protectedIds = [4, 18]; // Аквамарин, Аквамарин 2
      return !protectedIds.includes(Number(this.resResidentComplex.id));
    },
  },
  methods: {
    ...mapActions({
      getDoorphones: 'Doorphone/getMapDoorphones',
      getComplex: 'ResidentComplex/getComplex',
      deleteComplex: 'ResidentComplex/deleteComplex',
      updateComplex: 'ResidentComplex/updateComplex',
      viewComplex: 'ResidentComplex/viewComplex',
    }),
    getPassageType (item) {
      switch (item) {
        case 'B': return ', (Шлагбаум)';
        case 'G': return ', (Ворота)';
        default: return '';
      }
    },
    getOpeningType (item) {
      const labels = {
        C: 'Открытие по звонку',
        RC: 'Открытие по пультам',
        A: 'Приложение EvoLife',
        G: 'Распознавание ГРЗ',
      };
      const values = Array.isArray(item)
        ? item
        : item === 'CG'
          ? ['C', 'G']
          : (item ? String(item).split(',').map(v => v.trim()).filter(Boolean) : []);
      return values.map(v => labels[v]).filter(Boolean).join(', ');
    },
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterDoorphones();
      }
    },
    getResidentComplex () {
      this.viewComplex(this.$route.params.id)
        .then((res) => {
          this.resResidentComplex = res;
          this.comment = this.resResidentComplex.comment;
          this.attachedDoorphones = this.resResidentComplex.doorphones.map(doorphone => doorphone.id);
          this.attachedBarriers = this.resResidentComplex.barriers.map(barrier => barrier.id);
          this.name = this.resResidentComplex.name;
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Ошибка при загрузке жилого комплекса');
        });
    },
    removeComplex (id, name) {
      this.deleteComplex(id)
        .then(() => {
          this.$flash_success(`Жилой комплекс ${name} успешно удален`);
          this.$router.push({ name: 'ResidentialComplexes' });
        })
        .catch(() => {
          this.$flash_warning('Ошибка при удалении жилого комплекса');
        })
        .finally(() => {
          this.deleteDialog[id] = false;
        });
    },
    processSelectedItems () {
      const doorphonesId = [];
      const barriersId = [];

      this.selectedDoorphones.forEach((item) => {
        if (item.uniqueId.startsWith('b_')) {
          // шлагбаум
          const cleanId = item.uniqueId.replace('b_', '');
          barriersId.push(parseInt(cleanId, 10));
        } else {
          // домофон
          doorphonesId.push(parseInt(item.id, 10));
        }
      });

      return {
        doorphonesId,
        barriersId,
      };
    },

    validate () {
      if (this.name === null) {
        this.$flash_danger('Введите название ЖК');
        return;
      }

      const { doorphonesId, barriersId } = this.processSelectedItems();

      const tempComplex = {
        name: this.name,
        coordinates: this.resResidentComplex.coordinates,
        comment: this.comment,
        doorphones: [...new Set([...doorphonesId, ...(this.resResidentComplex.doorphones || []).map(item => item.id)])],
        barriers: [...new Set([...barriersId, ...(this.resResidentComplex.barriers || []).map(item => item.id)])],
      };

      this.updateComplex({
        id: this.$route.params.id,
        value: tempComplex,
      })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
          this.getResidentComplex();
        })
        .catch(() => {
          if (this.name) {
            this.$flash_warning(`Ошибка при редактировании ЖК ${this.name}`);
          } else {
            this.$flash_warning('Ошибка при редактировании ЖК');
          }
        });
    },

    removeAccessDevice (idDelete, isBarrier = false) {
      if (isBarrier) {
        // Если удаляем шлагбаум
        const barrierId = this.resResidentComplex.barriers.map(item => item.id);
        const filteredArray = barrierId.filter(id => id !== idDelete);
        this.listBarriersDelete = filteredArray.length > 0 ? filteredArray : [];

        this.updateComplex({
          id: this.$route.params.id,
          value: {
            name: this.resResidentComplex.name,
            coordinates: this.resResidentComplex.coordinates,
            doorphones: this.resResidentComplex.doorphones.map(item => item.id),
            barriers: this.listBarriersDelete,
          },
        })
          .then(() => {
            this.$flash_success('Изменения успешно сохранены');
            this.getResidentComplex();
          })
          .catch(() => {
            if (this.name) {
              this.$flash_warning(`Ошибка при редактирование ЖК ${this.name}`);
            } else {
              this.$flash_warning('Ошибка при редактирование ЖК');
            }
          });
      } else {
        // Если удаляем домофон
        const doorphoneId = this.resResidentComplex.doorphones.map(item => item.id);
        const filteredArray = doorphoneId.filter(id => id !== idDelete);
        this.listDoorphonesdelete = filteredArray.length > 0 ? filteredArray : [];

        this.updateComplex({
          id: this.$route.params.id,
          value: {
            name: this.resResidentComplex.name,
            coordinates: this.resResidentComplex.coordinates,
            doorphones: this.listDoorphonesdelete,
            barriers: this.resResidentComplex.barriers.map(item => item.id),
          },
        })
          .then(() => {
            this.$flash_success('Изменения успешно сохранены');
            this.getResidentComplex();
          })
          .catch(() => {
            if (this.name) {
              this.$flash_warning(`Ошибка при редактирование ЖК ${this.name}`);
            } else {
              this.$flash_warning('Ошибка при редактирование ЖК');
            }
          });
      }
    },
    loadDoorphones () {
      this.getDoorphones({
        filters: this.filters,
      })
        .then((res) => {
          let doorphones = [];
          let barriers = [];

          // загружаем только домофоны
          if (this.filters.doorphone_id) {
            doorphones = res.data.doorphones.map(item => ({
              ...item,
              uniqueId: `${item.id}`,
            })) || [];
          }

          // загружаем только шлагбаумы
          if (this.filters.barrier_id) {
            barriers = res.data.barriers.map(item => ({
              ...item,
              uniqueId: `b_${item.id}`,
            })) || [];
          }

          // Если фильтры не заданы, загружаем и домофоны, и шлагбаумы
          if (!this.filters.doorphone_id && !this.filters.barrier_id) {
            doorphones = res.data.doorphones.map(item => ({
              ...item,
              uniqueId: `${item.id}`,
            })) || [];

            barriers = res.data.barriers.map(item => ({
              ...item,
              uniqueId: `b_${item.id}`,
            })) || [];
          }

          this.SCUD = [...doorphones, ...barriers];

          if (this.SCUD.length > 0) {
            this.loading = false;
          }
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке домофонов');
          this.loading = false;
        });
    },
    filterDoorphones () {
      this.filters = {};

      if (this.filterAddress) {
        this.filters.address = this.filterAddress;
      }
      if (this.filterIdDoorphone) {
        this.filters.doorphone_id = this.filterIdDoorphone;
      }
      if (this.filterIdBarrier) {
        this.filters.barrier_id = this.filterIdBarrier;
      }
      this.$router.push({
        query: {
          address: this.filters.address,
        },
      }).catch(() => {});
      this.loadDoorphones();
    },
    close () {
      this.$router.push({ name: 'ResidentialComplexes' });
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-res-complex__col-left {
  padding-bottom: 16px;
}

.detail-res-complex__section {
  padding: 4px 0 8px;
}

.detail-res-complex__section-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  margin: 0 0 20px 0;
  letter-spacing: -0.01em;
}

.detail-res-complex__form-row {
  margin: 0 -12px;
}

.detail-res-complex__col {
  padding: 0 12px 16px !important;
}

.detail-res-complex__counters {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  align-items: center;
  font-size: 0.9375rem;
  color: #546e7a;
  min-height: 40px;
}

.detail-res-complex__counter {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  padding: 6px 12px;
  background: #f5f7f8;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.detail-res-complex__card {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.detail-res-complex__tabs ::v-deep .v-tabs-bar {
  background: #f5f7f8;
}

.detail-res-complex__tabs ::v-deep .v-tab {
  text-transform: none;
  font-weight: 500;
}

.detail-res-complex__tabs ::v-deep .v-tabs-bar__prev,
.detail-res-complex__tabs ::v-deep .v-tabs-bar__next {
  flex: 0 0 auto;
  min-width: 40px;
}

.detail-res-complex__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 20px 0 0;
}

.detail-res-complex__actions-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.detail-res-complex__progress {
  margin: 0;
}

.detail-res-complex__search-card {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.detail-res-complex__table-wrap {
  padding: 0 5px 5px;
}

.detail-res-complex__card ::v-deep .v-tabs-items {
  padding: 16px;
}

.detail-res-complex__filters {
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background: #fafafa;
}

.detail-res-complex__filters-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
}

.detail-res-complex__filters-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.detail-res-complex__field {
  max-width: 200px;
}

.detail-res-complex__search-btn {
  text-transform: none;
  font-weight: 500;
  margin-left: auto;
}

.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}

@media screen and (max-width: 960px) {
  .detail-res-complex__col-left {
    padding-bottom: 24px;
  }
}

@media screen and (max-width: 600px) {
  .detail-res-complex__section {
    padding: 0 0 12px;
  }
  .detail-res-complex__counters {
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 4px;
    -webkit-overflow-scrolling: touch;
  }
  .detail-res-complex__counter {
    padding: 6px 10px;
    font-size: 0.875rem;
    flex-shrink: 0;
  }
  .detail-res-complex__actions {
    flex-direction: column;
    align-items: flex-start;
  }
  .detail-res-complex__search-btn {
    margin-left: 0;
  }
}
</style>
